import { createSlice } from "@reduxjs/toolkit";
import jwtServices from "../../services/jwtServices";
import { setUserData } from "./userSlice";

export const submitLogin =
  ({ email, password }) =>
  async (dispatch) => {
    return jwtServices
      .signInWithEmailAndPassword(email, password)
      .then((user) => {
        dispatch(setUserData(user));
        return dispatch(loginSuccess());
      })
      .catch((err) => {
        dispatch(loginError());
      });
  };

const initialState = {
  success: false,
  errors: [],
};

const loginSlice = createSlice({
  name: "/login",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.success = true;
      state.errors = [];
    },
    loginError: (state, action) => {
      state.success = false;
      state.errors = action.payload;
    },
  },
  extraReducers: {},
});

export const { loginSuccess, loginError } = loginSlice.actions;

export default loginSlice.reducer;
